define('modules/editor/collections/bricks',['require','exports','module','backbone','./elements','../models/brick_factory'],function(require, exports, module) {
  var Backbone = require("backbone"),
      ElementCollection = require("./elements"),
      BrickFactory = require("../models/brick_factory");

  var Serialization = {
    fromJSON: function(json) {
      var elements = new module.exports();
      elements.reset(_.map(json, BrickFactory.fromJSON));
      return elements;
    }
  };

  module.exports = ElementCollection.extend({
    model: BrickFactory
  },
  {
    fromJSON: Serialization.fromJSON
  });

});

